import { useMutation, useQueryClient } from "@tanstack/react-query";
import { GatewayService } from "../api/gateway.service";

/** State and action returned by {@link useDeleteClient}. */
export interface UseDeleteClientReturn {
    /** Delete a client by id; resolves once the request completes. */
    deleteClient: (id: number) => Promise<unknown>;
    loading: boolean;
    error: Error | null;
    data: unknown;
}

/** Delete a client and drop it from the cached clients list on success. */
export const useDeleteClient = (): UseDeleteClientReturn => {
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: (id: number) => GatewayService.deleteClient(id),
        onSuccess: (_, id) => {
            queryClient.invalidateQueries({ queryKey: ["gateway", "clients"] });
            queryClient.removeQueries({ queryKey: ["gateway", "client", id] });
        },
    });
    return {
        deleteClient: (id) => mutation.mutateAsync(id),
        loading: mutation.isPending,
        error: mutation.error,
        data: mutation.data ?? null,
    };
};
